module.exports = __webpack_public_path__ + "img/ic_medium_video.276ee60b.svg";